import angular from 'angular';
angular.module('commonServices').filter('percentage', [
  '$filter',
  function($filter) {
    return function(input, decimals = 2) {
      return $filter('number')(input * 100, decimals) + '%';
    };
  },
]);
